// BTSearchBox.tsx
import React, { useState } from 'react';
import Search from '../../assets/icons/search.svg';
import styled from 'styled-components';
import BTBox from './BTBox';

interface BTSearchBoxProps {
  onSearch: (query: string) => void;
  /** 컨테이너 높이 (px). 셀렉트 박스와 맞추려면 44 추천 */
  height?: number;
  /** 컨테이너 폭. 숫자(px) 또는 퍼센트/문자열 */
  width?: number | string;
  /** placeholder 커스터마이즈 (optional) */
  placeholder?: string;
}

const BTSearchBox: React.FC<BTSearchBoxProps> = ({
  onSearch,
  height = 36,
  width = '100%',
  placeholder = 'Search...',
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') onSearch(inputValue);
  };

  return (
    <SearchContainer $height={height} $width={width}>
      <img
        src={Search}
        width={Math.max(20, Math.min(24, Math.round(height * 0.55)))}
        height={Math.max(20, Math.min(24, Math.round(height * 0.55)))}
        style={{ flex: '0 0 auto' }}
      />
      <BTBox width="6px" />
      <SearchInput
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </SearchContainer>
  );
};

export default BTSearchBox;

// ---- styles ----
// transient props 로 DOM 전달 방지: $height / $width
const SearchContainer = styled.div<{ $height: number; $width: number | string }>`
  display: flex;
  align-items: center;
  border: 1px solid #adb5bd;
  border-radius: 4px;
  padding: 0 10px;
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  height: ${({ $height }) => `${$height}px`};
  max-width: 100%;
  box-sizing: border-box;
  background: #fff;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  min-width: 0;
  font-size: 16px;
  color: #232d42;
  background-color: transparent;
  height: 100%;
  line-height: 1; /* 높이 맞춤 시 수직정렬 안정화 */

  &::placeholder {
    color: #adb5bd;
  }
`;